/* Saleha Art: puts each print's own painting into the Raining Mercy style photo (Files: sa-print-options-clean.png).
   Coordinates are pixels of that 1527 x 1614 photo. r = crop of each style, q = corners of the painting
   (top-left, top-right, bottom-right, bottom-left), c = outline of the visible painting, p = the "option" circle
   to cover, side = black canvas edge. Portrait or very wide paintings are drawn in their own shape (draw()).
   Duo sets and trios (data-set) are cut into their paintings and drawn side by side. Bundles of 4 (room photos),
   or a photo that can't be read, show the four cards with the Raining Mercy painting. */
(function () {
  var NW = 1527;
  var T = {
    poster: { r: [45,12,760,727], q: [[79,200],[405,40],[692,409],[226,570]], c: [[79,200],[336,71],[415,65],[459,111],[639,335],[667,375],[671,381],[616,385],[616,395],[606,400],[595,405],[586,410],[577,415],[570,420],[562,425],[551,430],[545,435],[535,440],[527,445],[518,450],[508,455],[499,460],[490,465],[482,470],[472,475],[460,480],[451,485],[443,490],[434,495],[371,521],[234,563],[211,528],[103,269]], p: [125,641,113,'#f6f6f6'] },
    framed: { r: [800,30,1460,690], q: [[1040,208],[1371,288],[1278,494],[887,372]], c: [[1040,208],[1371,288],[1278,494],[887,372]], p: [844,641,113,'#ffffff'] },
    canvas: { r: [50,788,740,1478], q: [[140,842],[691,903],[690,1360],[139,1403]], c: [[140,842],[691,903],[690,1360],[139,1403]], p: [125,1419,113,'#ececec'], side: [[121,838],[139,842],[139,1403],[121,1397]] },
    rolled: { r: [796,800,1466,1470], q: [[909,899],[1729,899],[1729,1514],[909,1514]], c: [[1220,899],[1458,899],[1458,1391],[1454,1423],[1411,1470],[904,1472],[904,1162],[941,1164],[964,1158],[998,1141],[1032,1119],[1066,1091],[1099,1068],[1128,1045],[1162,1017],[1184,992],[1195,966],[1207,932],[1213,910]], p: [843,1418,113,'#f1f1f1'] }
  };
  function expand(pts, d) {
    var cx = 0, cy = 0; pts.forEach(function (p) { cx += p[0]; cy += p[1]; }); cx /= pts.length; cy /= pts.length;
    return pts.map(function (p) { var dx = p[0] - cx, dy = p[1] - cy, l = Math.sqrt(dx * dx + dy * dy) || 1; return [p[0] + dx / l * d, p[1] + dy / l * d]; });
  }
  function m3d(w, h, q) {
    var x0=q[0][0],y0=q[0][1],x1=q[1][0],y1=q[1][1],x2=q[2][0],y2=q[2][1],x3=q[3][0],y3=q[3][1];
    var dx1=x1-x2,dx2=x3-x2,dx3=x0-x1+x2-x3,dy1=y1-y2,dy2=y3-y2,dy3=y0-y1+y2-y3,den=dx1*dy2-dx2*dy1;
    var g=(dx3*dy2-dx2*dy3)/den,hh=(dx1*dy3-dx3*dy1)/den;
    var a=x1-x0+g*x1,b=x3-x0+hh*x3,c=x0,d=y1-y0+g*y1,e=y3-y0+hh*y3,f=y0;
    return 'matrix3d('+[a/w,d/w,0,g/w,b/h,e/h,0,hh/h,0,0,1,0,c,f,0,1].join(',')+')';
  }
  function wid(i) { return i.naturalWidth || i.width; }
  function hgt(i) { return i.naturalHeight || i.height; }
  function load(src) { return new Promise(function (ok, no) { var i = new Image(); i.onload = function () { ok(i); }; i.onerror = no; i.src = src; }); }
  /* The product photo is a framed mockup: background, black frame, white mount, painting.
     Walk in from each side along several lines: past the background, past the frame, past the mount. */
  function findArt(img) {
    var W = 400, H = Math.round(W * hgt(img) / wid(img)), cv = document.createElement('canvas');
    cv.width = W; cv.height = H; var g = cv.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, W, H); g.drawImage(img, 0, 0, W, H);
    var d = g.getImageData(0, 0, W, H).data;
    function P(x, y) { var i = (y * W + x) * 4; return [d[i], d[i+1], d[i+2]]; }
    function L(p) { return (p[0] + p[1] + p[2]) / 3; }
    function S(p) { return Math.max(p[0], p[1], p[2]) - Math.min(p[0], p[1], p[2]); }
    /* returns [inner edge of the frame, start of the painting] along one line */
    function scan(get, n) {
      var k = 0, lim = n * .45, run = 0, start, inner;
      while (k < lim && L(get(k)) >= 130) k++;
      if (k >= lim) return null;
      while (k < lim && L(get(k)) < 150) k++;
      start = inner = k;
      while (k < lim) { var p = get(k); if (S(p) < 14 && L(p) > 135) { run = 0; start = k + 1; } else { run++; if (run >= 3) break; } k++; }
      return k >= lim ? null : [inner, start];
    }
    function med(a, i) { a = a.filter(function (v) { return v; }).map(function (v) { return v[i]; }).sort(function (x, y) { return x - y; }); return a.length ? a[Math.floor(a.length / 2)] : -1; }
    var fr = [.3, .38, .46, .54, .62, .7];
    var SL = fr.map(function (f) { return scan(function (k) { return P(k, Math.round(H * f)); }, W); });
    var SR = fr.map(function (f) { return scan(function (k) { return P(W - 1 - k, Math.round(H * f)); }, W); });
    var ST = fr.map(function (f) { return scan(function (k) { return P(Math.round(W * f), k); }, H); });
    var SB = fr.map(function (f) { return scan(function (k) { return P(Math.round(W * f), H - 1 - k); }, H); });
    var l = med(SL, 1), r = med(SR, 1), t = med(ST, 1), b = med(SB, 1);
    if (l < 0 || r < 0 || t < 0 || b < 0) return null;
    /* The white mount is the same width all round. Where a side looks wider, that edge of the painting is white
       or pale (e.g. the white right side of Repentance), so that side gets the mount width of the normal sides
       and the pale part of the painting is kept. */
    var iL = med(SL, 0), iR = med(SR, 0), iT = med(ST, 0), iB = med(SB, 0);
    var ms = [l - iL, r - iR, t - iT, b - iB], mn = Math.min.apply(null, ms);
    var ok = ms.filter(function (m) { return m <= mn + 6; }), ref = Math.round(ok.reduce(function (a, m) { return a + m; }, 0) / ok.length);
    if (ms[0] > mn + 6) l = iL + ref;
    if (ms[1] > mn + 6) r = iR + ref;
    if (ms[2] > mn + 6) t = iT + ref;
    if (ms[3] > mn + 6) b = iB + ref;
    var x0 = l, x1 = W - 1 - r, y0 = t, y1 = H - 1 - b;
    if (x1 - x0 < W * .3 || y1 - y0 < H * .3) return null;
    var ix = (x1 - x0) * .004, iy = (y1 - y0) * .004;
    return { x: (x0 + ix) / W, y: (y0 + iy) / H, w: (x1 - x0 - 2 * ix) / W, h: (y1 - y0 - 2 * iy) / H };
  }
  function crop(img, b) { /* the whole painting, fitted to the 4:3 painting in the photo (only used when it is close to 4:3, so nothing is cut off) */
    var sx = b.x * img.naturalWidth, sy = b.y * img.naturalHeight, sw = b.w * img.naturalWidth, sh = b.h * img.naturalHeight;
    var cv = document.createElement('canvas'); cv.width = 1000; cv.height = 750;
    cv.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, 1000, 750);
    return cv.toDataURL('image/jpeg', .9);
  }
  function stage(box, kind, base, art) {
    var t = T[kind], R = t.r, W = R[2] - R[0], H = R[3] - R[1];
    box.style.aspectRatio = W + ' / ' + H;
    var st = document.createElement('div'); st.className = 'sa-st'; st.style.width = W + 'px'; st.style.height = H + 'px';
    var bi = document.createElement('img'); bi.src = base; bi.alt = ''; bi.className = 'sa-st__base';
    bi.style.left = -R[0] + 'px'; bi.style.top = -R[1] + 'px'; bi.style.width = NW + 'px';
    st.appendChild(bi);
    var p = t.p, pd = document.createElement('div'); pd.className = 'sa-st__patch';
    pd.style.cssText = 'left:' + (p[0] - p[2] - R[0]) + 'px;top:' + (p[1] - p[2] - R[1]) + 'px;width:' + 2 * p[2] + 'px;height:' + 2 * p[2] + 'px;background:radial-gradient(circle,' + p[3] + ' 88%,transparent 100%)';
    st.appendChild(pd);
    if (t.side) st.insertAdjacentHTML('beforeend', '<svg class="sa-st__side" width="' + W + '" height="' + H + '"><polygon fill="#161616" points="' + t.side.map(function (a) { return (a[0] - R[0]) + ',' + (a[1] - R[1]); }).join(' ') + '"/></svg>');
    if (art) {
    var cl = document.createElement('div'); cl.className = 'sa-st__clip';
    cl.style.clipPath = 'polygon(' + expand(t.c, 2).map(function (a) { return (a[0] - R[0]) + 'px ' + (a[1] - R[1]) + 'px'; }).join(',') + ')';
    var ai = document.createElement('img'); ai.src = art; ai.alt = ''; ai.className = 'sa-st__art';
    ai.style.transform = m3d(1000, 750, t.q.map(function (a) { return [a[0] - R[0], a[1] - R[1]]; }));
    cl.appendChild(ai); st.appendChild(cl);
    }
    box.insertBefore(st, box.firstChild);
    function fit() { st.style.transform = 'scale(' + (box.clientWidth / W) + ')'; }
    fit(); if (window.ResizeObserver) new ResizeObserver(fit).observe(box);
  }
  /* Portrait (or very wide) paintings: draw the same four styles in the painting's own shape,
     on the same light backgrounds as the photo, so every print shows its own painting. */
  function cropOwn(img, b) {
    var sx = b.x * wid(img), sy = b.y * hgt(img), sw = b.w * wid(img), sh = b.h * hgt(img);
    var k = Math.min(1, 900 / Math.max(sw, sh)), cv = document.createElement('canvas');
    cv.width = Math.round(sw * k); cv.height = Math.round(sh * k);
    cv.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, cv.width, cv.height);
    return cv.toDataURL('image/jpeg', .9);
  }
  var BG = { poster: '#f6f6f6', framed: '#ffffff', canvas: '#ececec', rolled: '#f1f1f1' };
  function one(kind, art, w, h) {
    var s = 'width:' + w + '%;height:' + h + '%;';
    if (kind === 'poster') return '<div class="sa-pm sa-pm--poster" style="' + s + '"><div class="sa-pm__art" style="background-image:url(' + art + ')"></div><i class="sa-pm__curl"></i></div>';
    if (kind === 'framed') return '<div class="sa-pm sa-pm--framed" style="' + s + '"><div class="sa-pm__mount"><div class="sa-pm__art" style="background-image:url(' + art + ')"></div></div></div>';
    if (kind === 'canvas') return '<div class="sa-pm sa-pm--canvas" style="' + s + '"><i class="sa-pm__side" style="background-image:linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),url(' + art + ')"></i><div class="sa-pm__art" style="background-image:url(' + art + ')"></div></div>';
    return '<div class="sa-pm sa-pm--rolled" style="' + s + '"><div class="sa-pm__art" style="background-image:url(' + art + ')"></div><i class="sa-pm__curl"></i></div>';
  }
  /* arts / ratios: one painting, or the paintings of a set (side by side, or stacked when they are landscape) */
  function draw(box, kind, arts, ratios) {
    var n = arts.length, gap = 5, row = ratios.every(function (r) { return r < 1.05; }), html = '';
    if (row) {
      var sumR = ratios.reduce(function (a, r) { return a + r; }, 0), h = Math.min(n > 1 ? 50 : 62, (82 - (n - 1) * gap) / sumR);
      arts.forEach(function (a, i) { html += one(kind, a, h * ratios[i], h); });
    } else {
      var sumI = ratios.reduce(function (a, r) { return a + 1 / r; }, 0), w = Math.min(n > 1 ? 56 : 66, (80 - (n - 1) * gap) / sumI);
      arts.forEach(function (a, i) { html += one(kind, a, w, w / ratios[i]); });
    }
    box.style.aspectRatio = '1 / 1';
    box.style.background = BG[kind];
    box.classList.add('sa-pm-tile');
    box.insertAdjacentHTML('afterbegin', '<div class="sa-pm-set" style="flex-direction:' + (row ? 'row' : 'column') + ';gap:' + gap + '%">' + html + '</div>');
    var els = box.firstElementChild.querySelectorAll('.sa-pm');
    function size() { els.forEach(function (el) { var pw = el.offsetWidth; el.style.setProperty('--c', Math.round(pw * (kind === 'rolled' ? .3 : .2)) + 'px'); el.style.setProperty('--f', Math.max(3, Math.round(pw * .045)) + 'px'); el.style.setProperty('--m', Math.round(pw * .12) + 'px'); el.style.setProperty('--d', Math.round(pw * .07) + 'px'); }); }
    size(); if (window.ResizeObserver) new ResizeObserver(size).observe(box);
  }
  /* A set photo shows its paintings in a row (or stacked): cut it into equal parts and find the painting in each. */
  function splitSet(img, n, dir) {
    var out = [], W = wid(img), H = hgt(img);
    for (var i = 0; i < n; i++) {
      var cv = document.createElement('canvas'), sx = dir === 'rows' ? 0 : W * i / n, sy = dir === 'rows' ? H * i / n : 0, sw = dir === 'rows' ? W : W / n, sh = dir === 'rows' ? H / n : H;
      /* stay 1% away from each cut, so a sliver of the neighbouring frame isn't mistaken for this frame */
      var e = (dir === 'rows' ? H : W) * .01, a0 = i > 0 ? e : 0, a1 = i < n - 1 ? e : 0;
      if (dir === 'rows') { sy += a0; sh -= a0 + a1; } else { sx += a0; sw -= a0 + a1; }
      cv.width = Math.round(sw); cv.height = Math.round(sh);
      cv.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, cv.width, cv.height);
      var b = findArt(cv);
      if (!b) return null;
      out.push({ art: cropOwn(cv, b), ratio: (b.w * cv.width) / (b.h * cv.height) });
    }
    return out;
  }

  document.querySelectorAll('.sa-po[data-base]').forEach(function (root) {
    function local(u) { return String(u || '').replace(/^(https?:)?\/\/[^\/]+/, ''); } /* same-site path so the canvas can read it on any domain */
    var base = local(root.getAttribute('data-base')), grid = root.querySelector('.sa-po__grid');
    if (!grid) return;
    var cards = grid.querySelectorAll('.sa-po__card[data-kind]');
    function show(fn) { root.classList.add('is-swapped'); grid.hidden = false; cards.forEach(function (c) { fn(c.querySelector('.sa-po__img'), c.getAttribute('data-kind')); }); }
    function plain() { show(function (box, kind) { stage(box, kind, base, null); }); }
    var artSrc = root.getAttribute('data-art'), setSrc = root.getAttribute('data-set');
    if (!artSrc && setSrc) {
      var n = parseInt(root.getAttribute('data-set-n'), 10) || 2, dir = root.getAttribute('data-set-dir') || 'cols';
      Promise.all([load(local(setSrc)), load(base)]).then(function (res) {
        var parts = splitSet(res[0], n, dir), pick = parseInt(root.getAttribute('data-set-pick'), 10);
        if (!parts) return plain();
        if (pick) parts = [parts[pick - 1]]; /* bundles: show one painting from the set */
        show(function (box, kind) { draw(box, kind, parts.map(function (p) { return p.art; }), parts.map(function (p) { return p.ratio; })); });
      }).catch(function () { load(base).then(plain).catch(function () {}); });
      return;
    }
    if (!artSrc) { load(base).then(plain).catch(function () {}); return; }
    Promise.all([load(local(artSrc)), load(base)]).then(function (res) {
      var img = res[0], b = findArt(img);
      if (!b) return plain();
      var ratio = (b.w * img.naturalWidth) / (b.h * img.naturalHeight);
      if (ratio >= 1.22 && ratio <= 1.45) {
        /* the rolled canvas in the photo only shows part of the painting, so that card is drawn whole instead */
        var art = crop(img, b), whole = cropOwn(img, b);
        show(function (box, kind) { if (kind === 'rolled') draw(box, kind, [whole], [ratio]); else stage(box, kind, base, art); });
      }
      else { var own = cropOwn(img, b); show(function (box, kind) { draw(box, kind, [own], [ratio]); }); }
    }).catch(function () { load(base).then(plain).catch(function () {}); });
  });
})();
